const HANGUL_CHOSEONG = [
  'ㄱ',
  'ㄲ',
  'ㄴ',
  'ㄷ',
  'ㄸ',
  'ㄹ',
  'ㅁ',
  'ㅂ',
  'ㅃ',
  'ㅅ',
  'ㅆ',
  'ㅇ',
  'ㅈ',
  'ㅉ',
  'ㅊ',
  'ㅋ',
  'ㅌ',
  'ㅍ',
  'ㅎ',
] as const;

function hangulChoseong(ch: string): string {
  const code = ch.codePointAt(0);
  if (code == null || code < 0xac00 || code > 0xd7a3) return ch;
  return HANGUL_CHOSEONG[Math.floor((code - 0xac00) / 588)] ?? ch;
}

/** 1부터 세는 글자 위치의 한글 음절만 초성으로 바꾼다. 이미 초성이거나 한글이 아니면 그대로 둔다. */
export function maskNameChoseong(name: string, positions: ReadonlySet<number>): string {
  if (positions.size === 0) return name;
  return Array.from(name)
    .map((ch, index) => (positions.has(index + 1) ? hangulChoseong(ch) : ch))
    .join('');
}

export function normalizeNameChoseongPositions(raw: unknown): number[] | undefined {
  if (!Array.isArray(raw)) return undefined;
  const unique = Array.from(
    new Set(
      raw
        .map((n) => (typeof n === 'number' ? n : Number(n)))
        .filter((n) => n === 1 || n === 2 || n === 3 || n === 4)
    )
  ).sort((a, b) => a - b);
  return unique.length > 0 ? unique : undefined;
}

type ClassMemberNameSource = {
  name?: string;
  nameChoseongPositions?: number[];
};

/** 저장된 이름은 그대로 두고, 초성 설정이 있을 때만 표시용 문자열을 만든다. */
export function displayClassMemberName(member: ClassMemberNameSource): string {
  const raw = member.name ?? '';
  const positions = member.nameChoseongPositions;
  if (!positions || positions.length === 0) return raw;
  return maskNameChoseong(raw, new Set(positions));
}

/** 입력·태그 매칭은 화면 이름과 저장된 이름을 함께 본다. */
export function classMemberNameMatches(
  member: ClassMemberNameSource,
  keyword: string,
  mode: 'includes' | 'exact'
): boolean {
  const k = keyword;
  if (!k) return false;
  const real = member.name ?? '';
  const shown = displayClassMemberName(member);
  const names = shown === real ? [real] : [shown, real];
  if (mode === 'exact') return names.some((n) => n === k);
  return names.some((n) => n.includes(k));
}
